// estudantes-report.service.ts
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { ApiService } from '@core/providers/http/api.service';

export interface ReportFilters {
  titulo?: string | number; // tipo de relatório
  anoInscricao?: number | null;
  nivelAcademico?: number | null;
  areaConhecimentoId?: number | null;
  cursoId?: number | null;
  inicioFormacao?: string | null; // 'YYYY-MM-DD'
  fimFormacao?: string | null; // 'YYYY-MM-DD'
  instituicaoId?: number | null;
  paisId?: number | null;
  instituicaoGestoraId?: number | null;
  genero?: number | null;
  idadeMinima?: number | null;
  idadeMaxima?: number | null;
  estadoBolsaId?: number | null;
  // paginação/opcional
  pageNumber?: number;
  anoCurricular?: number | null;
  pageSize?: number;
  OrderBy?: string;
}

@Injectable({ providedIn: 'root' })
export class EstudantesReportService {
  private readonly bolseirosBaseUrl = environment.apiBolseirosUrl.replace(/\/+$/, '');
  private apiUrl = this.bolseirosBaseUrl.endsWith('/bolsa')
    ? this.bolseirosBaseUrl
    : `${this.bolseirosBaseUrl}/bolsa`;
  private path = this.bolseirosBaseUrl.endsWith('/bolsa') ? '' : 'bolsa';

  constructor(private http: HttpClient, private apiService: ApiService) {}

  /** Util: remove null/undefined/'' */
  private clean<T extends object>(obj: T): Partial<T> {
    return Object.fromEntries(
      Object.entries(obj).filter(
        ([_, v]) => v !== null && v !== undefined && v !== ''
      )
    ) as Partial<T>;
  }

  /** Util: converte filtros em HttpParams (suporta arrays se precisares no futuro) */
  private toHttpParams(filters: Partial<ReportFilters>): HttpParams {
    let params = new HttpParams();
    Object.entries(filters).forEach(([k, v]) => {
      if (Array.isArray(v)) {
        v.forEach((item) => {
          if (item !== null && item !== undefined && item !== '')
            params = params.append(k, String(item));
        });
      } else if (v !== null && v !== undefined && v !== '') {
        params = params.set(k, String(v));
      }
    });
    return params;
  }

  /** Lista/paginação no grid com filtros (reaproveita a mesma limpeza) */
  filtrarEstudantes(filters: ReportFilters): Observable<any> {
    const params = this.toHttpParams(this.clean(filters));
    return this.apiService.get(`${this.path}/filtro`, params);
  }

  //  downloadPdfByFilters(filters: ReportFilters): Observable<Blob> {
  //     const headers = new HttpHeaders().set('Accept', 'application/pdf');
  //     const params = this.toHttpParams(this.clean(filters));
  //     return this.http.get(`${this.apiUrl}bolsa/Relatorio_Filtro`, {
  //       headers,
  //       params,
  //       responseType: 'blob',
  //     });
  //   }

  downloadPdfByFilters(params: Record<string, any>): Observable<Blob> {
    const headers = new HttpHeaders().set('Accept', 'application/pdf');

    // limpa nulos/vazios
    const cleaned = Object.fromEntries(
      Object.entries(params ?? {}).filter(
        ([, v]) => v !== null && v !== undefined && v !== ''
      )
    ) as Record<string, string>;

    const httpParams = new HttpParams({ fromObject: cleaned });

    return this.http.post(`${this.apiUrl}/Relatorio_Filtro`, null, {
      headers,
      params: httpParams, // <-- vai como query string
      responseType: 'blob',
    });
  }

  downloadExcelByFilters(filters: ReportFilters): Observable<Blob> {
    const headers = new HttpHeaders().set(
      'Accept',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    );
    const params = this.toHttpParams(this.clean(filters));
    return this.http.get(`${this.apiUrl}/GerarExcelBolsa`, {
      headers,
      params,
      responseType: 'blob',
    });
  }
}
